import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    selector: 'app-text-lightbox',
    templateUrl: './text-lightbox.component.html',
    styleUrl: './text-lightbox.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextLightboxComponent {

    constructor(@Inject(MAT_DIALOG_DATA) protected data: { title: string, content: string }) {
    }
}
